import {SVGProps, useId} from 'react';

import {COLORS} from '@/styles/colors';

export const DocumentCheckIcon = (props: SVGProps<SVGSVGElement>) => {
  const maskId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? '24px'}
      height={props.height ?? '24px'}
      fill="none"
      {...props}>
      <mask
        id={maskId}
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}>
        <path
          fill={COLORS.BACKGROUND_ON_SECONDARY_CONTAINER}
          d="M0 0h24v24H0z"
        />
      </mask>
      <g mask={'url(#' + maskId + ')'}>
        <path
          fill={props.color ?? COLORS.ON_SURFACE_1}
          d="m10.931 15.006-1.37-1.37a1.092 1.092 0 0 0-.343-.235.972.972 0 0 0-.382-.078 1.054 1.054 0 0 0-.746.312 1.014 1.014 0 0 0-.313.745c0 .288.104.537.312.746l2.06 2.078c.111.112.236.194.372.246.137.052.28.077.43.077.149 0 .291-.026.428-.077.136-.052.26-.134.373-.246l4.159-4.159c.208-.208.312-.46.312-.755s-.104-.547-.312-.755a1.03 1.03 0 0 0-.755-.312c-.295 0-.547.104-.755.312l-3.47 3.47Zm-4.86 7.197c-.629 0-1.165-.221-1.609-.665a2.193 2.193 0 0 1-.665-1.61V4.072c0-.63.222-1.166.665-1.61.444-.443.98-.665 1.61-.665h7.073a2.244 2.244 0 0 1 1.598.659l4.802 4.802a2.244 2.244 0 0 1 .659 1.598v11.072c0 .63-.222 1.167-.666 1.61-.443.444-.98.665-1.61.665H6.072Zm6.857-14.269V4.072H6.072v15.856h11.856V9.072h-3.862a1.1 1.1 0 0 1-.808-.33 1.1 1.1 0 0 1-.33-.808Z"
        />
      </g>
    </svg>
  );
};
